const typeDisplayOptions = 
[
[
  { value: 'home', label: 'My Dashboard' },
  { value: 'rsv', label: 'RSV Incidence' },
  { value: 'flu', label: 'Flu Incidence' },
  { value: 'covid', label: 'COVID-19 Incidence' },
  { value: 'vulnerability', label: 'Vulnerability' },
  { value: 'allergies', label: 'Allergies and Air Quality' },
  { value: 'birthtrend', label: 'Births & Trends' },
],
[
  { value: 'home', label: 'My Dashboard' },
  { value: 'rsv', label: 'RSV Incidence' },
  { value: 'flu', label: 'Flu Incidence' },
  { value: 'covid', label: 'COVID-19 Incidence' },
],
[
  { value: 'home', label: 'My Dashboard' },
  { value: 'rsv', label: 'RSV Incidence' },
  { value: 'flu', label: 'Flu Incidence' },
  { value: 'covid', label: 'COVID-19 Incidence' },
  { value: 'vulnerability', label: 'Vulnerability' },
  { value: 'allergies', label: 'Allergies and Air Quality' },
  { value: 'birthtrend', label: 'Births & Trends' },
  { value: 'uti', label: 'UTI Dashboard' },
  { value: 'meningitis', label: 'Meningitis Dashboard' },
  { value: 'shingles', label: 'Shingles Dashboard' },
],
]

export default typeDisplayOptions